import React from "react";
import imagesCss from "../../../assets/styles/images/images.module.scss";
import ImageViewer from "./ImageViewer";
import { Header } from "semantic-ui-react";
const ImagesEditor = ({ imageState, setImageState }) => {
  return (
    <div className={imagesCss.imagesEditor}>
      <div className={imagesCss.imagesEditorSection}>
        <div
          className={imagesCss.requirementsHeader}
          style={{
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "start",
          }}
        >
          <Header as="h3">Upload Images & Add Keywords</Header>
          <span>
            You can upload multiple images. Accepted formats: JPG, PNG. Max
            size: 5MB each.
          </span>
        </div>
        <ImageViewer imageState={imageState} setImageState={setImageState} />
      </div>
    </div>
  );
};

export default ImagesEditor;
